export { default as URL } from "./urls";
export const TransactionNotificationComment = "transaction comment";
export const LeaseEventNotificationComment = "lease event comment";
export const PreTransactionNotificationComment = "pre transaction comment";
export const LeaseEvent = "lease event";
export const Transaction = "transaction";
export const TransactionDeleteRequest = "transaction delete request";
export const PreTransactionDeleteRequest = "pre-transaction delete request";